import { render, staticRenderFns } from "./PostponeLogs.vue?vue&type=template&id=e86e85c6&scoped=true"
import script from "./PostponeLogs.vue?vue&type=script&lang=js"
export * from "./PostponeLogs.vue?vue&type=script&lang=js"
import style0 from "./PostponeLogs.vue?vue&type=style&index=0&id=e86e85c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86e85c6",
  null
  
)

export default component.exports